import { useEffect } from "react";

export const useMatomoTM = () => {
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  useEffect(() => {
    if (VITE_APP_PROJECT_NAME === "banger") {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      // eslint-disable-next-line no-multi-assign, no-underscore-dangle
      const _mtm = (window._mtm = window._mtm || []);
      _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
      // eslint-disable-next-line func-names
      (function () {
        const d = document;
        const g = d.createElement("script");
        const s = d.getElementsByTagName("script")[0];
        g.async = true;
        g.src = "https://matomo.glorycoin.co/js/container_eSRXNBga.js";
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        s.parentNode.insertBefore(g, s);
      })();
    }
  }, [VITE_APP_PROJECT_NAME]);
};
